export enum DashboardConfigsEnum {
  PAGE_SIZE = 50,
}
